export default __webpack_public_path__ + "static/media/wave.fd7731fd.gif";